import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { variantsStaggerContainer, variantsStaggerItem } from '../../lib/motion';
import { cn } from '../../lib/cn';
import { useReducedMotion } from '../../hooks/useReducedMotion';

interface StaggerGridProps {
  children: ReactNode;
  className?: string;
}

export function StaggerGrid({ children, className }: StaggerGridProps) {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div
      variants={reducedMotion ? undefined : variantsStaggerContainer}
      initial={reducedMotion ? false : 'hidden'}
      whileInView={reducedMotion ? undefined : 'visible'}
      viewport={{ once: true, margin: '-80px' }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

interface StaggerItemProps {
  children: ReactNode;
  className?: string;
}

export function StaggerItem({ children, className }: StaggerItemProps) {
  return (
    <motion.div variants={variantsStaggerItem} className={cn(className)}>
      {children}
    </motion.div>
  );
}
